import { parseBooleanValue } from "../../util";
import { ILegalView } from "../../legalViews/model/LegalView";
import SummaryTranslationParamMapper from "../../core/service/translations/SummaryTranslationParamMapper";

const LegalViewParamMapper = (item: ILegalView) => {
  return {
    ...item,
    valid: parseBooleanValue(item.valid),
    summaryTranslations: item.summaryTranslations.map((item) =>
      SummaryTranslationParamMapper(item)
    )
  };
};

export default LegalViewParamMapper;
